<template>
  <div>
    <p class="mb-6 text-sm">Your choices will be selected at random.</p>
    <table class="w-full">
      <thead class="text-xs uppercase border-t border-b">
        <th class="py-3 px-2 text-left">Song Title</th>
        <th class="py-3 px-2">Preview</th>
        <!-- <th class="py-3 px-2">Brief Description</th> -->
        <th class="py-3 px-2">Select</th>
      </thead>
      <tbody>
        <tr
          v-for="(song, index) in songs"
          :key="index"
          class="border-b"
          :class="{
            'bg-blue-lightest': index % 2 === 0
          }"
        >
          <td class="py-6 px-2 capitalize">{{ song.title }}</td>
          <td class="px-2 text-center">
            <i
              v-if="playing === index"
              class="far fa-pause-circle fa-fw fa-2x"
              @click="pause(index)"
            />
            <i
              v-else
              class="far fa-play-circle fa-fw fa-2x"
              @click="play(index)"
            />
            <audio
              :ref="'song_' + index"
              :src="song.path"
            >
            </audio>
          </td>
          <!-- <td class="py-6 px-2 text-center">{{ song.description }}</td> -->
          <td class="py-6 px-2 text-center">
            <input
              :id="'song_' + index"
              type="checkbox"
              class="blue"
              :value="song"
              v-model="options"
            />
            <label :for="'song_' + index" class="bg-white"></label>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { head } from 'lodash'

export default {
  name: 'BackingMusic',

  props: ['value'],

  data () {
    return {
      playing: null
    }
  },

  computed: {
    ...mapState({
      songs: state => state.videoettes.backingMusicItems
    }),

    options: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },

  methods: {
    play (index) {
      this.pause(this.playing)

      const audio = head(this.$refs['song_' + index])
      if (audio) {
        audio.play()
        this.playing = index
      }
    },

    pause (index) {
      if (index === null) return

      const audio = head(this.$refs['song_' + index])
      if (audio) {
        audio.pause()
      }

      this.playing = null
    }
  }
}
</script>

<style scoped>
/* Margin right is defined globally, wont change so resetting here instead so we can have a white background.*/
input[type="checkbox"] + label::before {
  margin-right: 0;
}
</style>
